export default {
  name: "UserCircle",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M16 2C8.28 2 2 8.28 2 16s6.28 14 14 14 14-6.28 14-14S23.72 2 16 2zM9.02 25.74C9.22 20.11 15.72 20 16 20c.28 0 6.78.11 6.98 5.74A11.877 11.877 0 0 1 16 28c-2.61 0-5.01-.84-6.98-2.26zM12 14.17c-.05-1.16.36-2.23 1.15-3.02A4.04 4.04 0 0 1 16 10h.18c1.89.08 3.75 1.93 3.82 3.82.05 1.16-.36 2.23-1.15 3.02-.79.79-1.86 1.2-3.02 1.15-1.89-.07-3.75-1.93-3.83-3.82zm12.8 9.97c-.64-2.98-2.81-4.63-5.03-5.44.17-.14.33-.28.49-.44 1.19-1.19 1.81-2.79 1.74-4.51-.12-2.94-2.8-5.62-5.74-5.74-1.72-.06-3.32.55-4.51 1.74s-1.81 2.79-1.74 4.51c.07 1.7 1 3.32 2.34 4.4-2.26.8-4.49 2.45-5.14 5.48C5.22 21.99 4 19.14 4 16 4 9.38 9.38 4 16 4s12 5.38 12 12c0 3.14-1.22 5.99-3.2 8.14z",
  },
}
